import React from "react";
import bnr from "../../../Assets/Images/OfferBanner.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Offer_banner() {

   useEffect(() => {
      AOS.init({
        duration: 1000, // Duration of the animation
        easing: "ease-in-out",
        once: false,
        offset: 100,  // Trigger when the element is 100px from the viewport
    delay: 200, // Animation triggers only once
      });
    }, []);
  return (
    <div className="lg:mt-28 md:mt-[70px] mt-[70px]">
      <img
        src={bnr}
        alt=""
        className="rounded-lg lg:px-11 py-1 w-auto md:px-5 px-2 h-auto"
      />
    </div>
  );
}

export default Offer_banner;
